<template>
    <div class="partySecondPageWarp">
        <div class="menubox">
            <NavMenu/>
        </div>
        <div class="commoncrumbsBox">
            <img :src="img1" alt="" class="topimgbox">
            <div class="pagetopbox">
                <div class="crumbsBox">
                    <div>
                        您当前所在位置：{{currentMenu}}-{{tabactiveTitle}}
                    </div>
                </div>
            </div>
        </div>
        <div class="typeArae">
            <div class="contentWarp">
                <div class="tabsWarp">
                    <router-link v-for="(item,index) in tabsList" :key="index" class="tabItemBox" active-class="nav-link" :to="item.url" @click.native="jump(item)">
                        <span :class="tabactiveTitle==item.name?'activetext':'text'">{{item.name}}</span>
                    </router-link>
                </div>
                <div class="componentBox">
                    <router-view />
                </div>
            </div>
        </div>
        <div class="footerbox">
            <Footer/>
        </div>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer
    },
    data() {
        return {
            srcUrl: srcUrl,
            img1: require("@/assets/imgs/party/img1.png"),
            tabsList: [
                { name: '党建引领', url: "/party-secondpage/party-leads" },
                { name: '党建动态', url: "/party-secondpage/party-dynamic" },
                { name: '学习园地', url: "/party-secondpage/study-section" },
                { name: '会员党建', url: "/party-secondpage/party-member" },
            ],
            tabactiveTitle: '党建引领',
            currentMenu: sessionStorage.getItem('clickMenu')
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                this.tabactiveTitle = val.meta.title
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {

    },
    methods: {
        jump() {
            this.tabactiveTitle = this.$route.meta.title;
            sessionStorage.removeItem('currentNew')
            sessionStorage.removeItem('childMenuObj')
        },

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.partySecondPageWarp {
	width: 100%;
	.menubox {
		width: 100%;
	}
	.commoncrumbsBox {
		width: 100%;
		position: relative;
		.topimgbox {
			width: 100%;
			// height: 300px;
		}
		.pagetopbox {
			width: 100%;
			margin: 0 auto;
			background: rgba(51, 51, 51, 0.23);
			box-sizing: border-box;
			position: absolute;
			bottom: 5px;
			left: 0px;
			.crumbsBox {
				width: 1200px;
				margin: 0 auto;
				padding: 20px 0 20px 0px;
				color: #fff;
			}
		}
	}
	.contentWarp {
		width: 1200px;
		min-height: 400px;
		margin: 0 auto;
		.componentBox {
			margin: 40px 0 0px 0;
		}
	}
}
</style>


